import { DataTableValue } from 'primereact/datatable';

export const getExpandedIndex = (
  data: DataTableValue[] | null | undefined,
  expandedRow: DataTableValue | null | undefined,
  dataKey: string
): number => {
  if (!expandedRow || !data) return -1;
  // Match by dataKey, not reference: a reload swaps in fresh row objects.
  return data.findIndex(
    (row) => String(row[dataKey]) === String(expandedRow[dataKey])
  );
};
